export const checkForDoubleCheck = (doubleCheck: any) => {
  if (doubleCheck && doubleCheck.id) {
    if (doubleCheck.change_requested_at) {
      return "changeRequested";
    }
    return "doubleCheck";
  }
  return "";
};
